module.exports = __webpack_public_path__ + "static/Predoc-e7c56ff0c8c72859c2e4921d65945608.png";